var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6601 0.00012207C18.0601 0.00012207 20.0001 1.92012 20.0001 5.33012V14.6701C20.0001 18.0601 18.0701 20.0001 14.6701 20.0001H5.33012C1.92012 20.0001 0.00012207 18.0601 0.00012207 14.6701V5.33012C0.00012207 1.92012 1.92012 0.00012207 5.33012 0.00012207H14.6601ZM9.99012 5.51012C9.53012 5.51012 9.16012 5.88012 9.16012 6.34012V9.16012H6.33012C6.11012 9.16012 5.90012 9.25012 5.74012 9.40012C5.59012 9.56012 5.50012 9.76912 5.50012 9.99012C5.50012 10.4501 5.87012 10.8201 6.33012 10.8301H9.16012V13.6601C9.16012 14.1201 9.53012 14.4901 9.99012 14.4901C10.4501 14.4901 10.8201 14.1201 10.8201 13.6601V10.8301H13.6601C14.1201 10.8201 14.4901 10.4501 14.4901 9.99012C14.4901 9.53012 14.1201 9.16012 13.6601 9.16012H10.8201V6.34012C10.8201 5.88012 10.4501 5.51012 9.99012 5.51012Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.461d358a.svg";
export { ForwardRef as ReactComponent };